<template>
    <div class="container pt-3 pt-md5 px-0">
        <bb-findflight></bb-findflight>
    </div>
</template>

<script>
    import { mdbContainer, mdbCol, mdbRow, mdbIcon, mdbTabs, mdbJumbotron, mdbView, mdbMask, mdbBtn, mdbTextarea, mdbInput, mdbCarousel, mdbCarouselItem,mdbCard, mdbCardImage, mdbCardBody, mdbCardTitle, mdbCardText, mdbCarouselCaption } from 'mdbvue';

    import findFlight from '@/components/findFlight';
    // In your VueJS component.
    import { VueperSlides, VueperSlide } from 'vueperslides'

    // Since v. 1.6.0, you need to include Vueper Slides CSS file for default styles.
    import 'vueperslides/dist/vueperslides.css'
    export default {
        name: "searchBar",
        components: {
            mdbContainer,
            mdbCol,
            mdbRow,
            mdbIcon,
            mdbTabs,
            mdbJumbotron,
            mdbView,
            mdbMask,
            mdbBtn,
            mdbTextarea,
            mdbInput,
            mdbCarouselItem,
            mdbCard,
            mdbCardImage,
            mdbCardBody,
            mdbCardTitle,
            mdbCardText,
            mdbCarousel,
            mdbCarouselCaption,
            VueperSlides, VueperSlide,
            'bb-findflight':findFlight,
        },
        data(){
            return {
                dnone:false,
            }
        }
    }
</script>

<style scoped>

</style>
